import { Provider } from '@angular/core';

import { PaymentQrRepository } from '@app/domain/ports/payment-qr.repository';
import { PaymentQrMerchantsRepository } from '@app/domain/ports/payment-qr-merchants.repository';
import { ListQrMerchantsUseCase } from '@app/domain/use-cases/payments-qr/list-qr-merchants.use-case';
import { PaymentQrRemoteDataSource } from '@app/data/data-sources/remote/payment-qr-remote.data-source';
import { PaymentQrMockDataSource } from '@app/data/data-sources/mock/payment-qr-mock.data-source';
import { PaymentQrMerchantsAdapter } from '@app/data/adapters/payment-qr-merchants.adapter';

/**
 * Port del cobro QR con toggle mock/remote. Reutiliza `environment.useMocks`
 * (el mismo de `PolipayPaymentsRepository`) a propósito: una llave nueva de
 * `Environment` exigiría tocar los cuatro `deploy-*.yml`, el template y el
 * generador. Se registra en `app.config`: lo exigía la sonda de disponibilidad
 * del menú lateral, retirada el 2026-10-02. Hoy solo lo usan la pantalla y su
 * ventana; bajarlo a nivel de componente es un cambio aparte.
 *
 * Recibe el booleano para que su spec pruebe las dos ramas sin tocar `environment`.
 */
export function providePaymentQrRepository(useMocks: boolean): Provider {
  return {
    provide: PaymentQrRepository,
    useClass: useMocks ? PaymentQrMockDataSource : PaymentQrRemoteDataSource,
  };
}

/**
 * Port chico del campo "Comercio" (RS1) + su caso de uso. Va a nivel de
 * COMPONENTE (en `providers` de la ventana del QR), igual que
 * `provideCardsEntities()`: solo la ventana lo usa, así que se crea y destruye
 * con ella. Sin toggle propio: mock/remote lo decide `PolipayPaymentsRepository`,
 * sobre el que delega el adapter.
 */
export function providePaymentQrMerchants(): Provider[] {
  return [
    { provide: PaymentQrMerchantsRepository, useClass: PaymentQrMerchantsAdapter },
    ListQrMerchantsUseCase,
  ];
}
